import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const buildPages = (current, total) => {
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }
  const delta = 1;
  const left = Math.max(2, current - delta);
  const right = Math.min(total - 1, current + delta);

  const pages = [1];
  if (left > 2) pages.push("...");
  for (let i = left; i <= right; i++) pages.push(i);
  if (right < total - 1) pages.push("...");
  pages.push(total);
  return pages;
};

const Pagination = ({
  currentPage,
  totalPages,
  perPage = 12,
  total = 0,
  onPageChange,
  showRange = true,
}) => {
  if (!totalPages || totalPages < 1) return null;

  console.log(perPage, total, totalPages);
  const rangeStart = total > 0 ? (currentPage - 1) * perPage + 1 : 0;
  const rangeEnd = Math.min(currentPage * perPage, total);

  const handleClick = (page) => {
    if (page < 1 || page > totalPages || page === currentPage) return;
    onPageChange(page);
  };

  return (
    <div className="lb-pagination">
      {showRange && total > 0 && (
        <span className="lb-range-text">
          {rangeStart}–{rangeEnd} of {total}
        </span>
      )}

      {totalPages > 1 && (
        <div className="lb-pages">
          <button
            type="button"
            className="lb-page-btn lb-page-nav"
            onClick={() => handleClick(currentPage - 1)}
            disabled={currentPage === 1}
            aria-label="Previous page"
          >
            <ChevronLeft size={15} />
          </button>

          {buildPages(currentPage, totalPages).map((page, idx) =>
            page === "..." ? (
              <span key={`ellipsis-${idx}`} className="lb-page-ellipsis">
                ...
              </span>
            ) : (
              <button
                key={page}
                type="button"
                className={`lb-page-btn${currentPage === page ? " active" : ""}`}
                onClick={() => handleClick(page)}
              >
                {page}
              </button>
            ),
          )}

          <button
            type="button"
            className="lb-page-btn lb-page-nav"
            onClick={() => handleClick(currentPage + 1)}
            disabled={currentPage === totalPages}
            aria-label="Next page"
          >
            <ChevronRight size={15} />
          </button>
        </div>
      )}
    </div>
  );
};

export default Pagination;
